import React from "react";
import _ from "lodash";
import { Row } from "reactstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Navigation from "../../navigation/containers/navigation";
import eventType from "../../../prop-types/eventType";
import networkItemType from "../../../prop-types/networkItem";
import { updateFilters } from "../../../state/filters/actions";
import "../styles/network.scss";
import NetworkCard from "../components/network-card";

const propTypes = {
  tabName: PropTypes.string.isRequired,
  types: PropTypes.arrayOf(eventType).isRequired,
  // mapStateToProps
  network: PropTypes.arrayOf(networkItemType).isRequired,
  filters: PropTypes.shape({
    conferenceId: PropTypes.number,
    clientId: PropTypes.number,
    sport: PropTypes.number
  }).isRequired
};

/*
 * This is the network functionality container showing for organization clients
 * to be able to go to any conference home website; from here conferences are
 * organization children, so we pass that as relatives collection
 */
function Network(props) {
  const { tabName, types, network } = props;

  return (
    <div
      role="region"
      className="network-container d-flex flex-column h-100 px-0 container-fluid"
    >
      <Navigation tabName={tabName} types={types} />
      <div className="d-flex flex-column network-list-container pr-0">
        <div className="pl-2 py-3">
          <h1 className="h3">Network</h1>
          {_.isEmpty(network) && <h3>No conferences found</h3>}
          {!_.isEmpty(network) && (
            <Row className="network-list mx-0">
              {network.map((client, i) => (
                <NetworkCard
                  idx={i}
                  key={`client-${client.clientName}-card`}
                  networkClient={client}
                />
              ))}
            </Row>
          )}
        </div>
      </div>
    </div>
  );
}

Network.propTypes = propTypes;

const mapStateToProps = (state) => ({
  client: state.client.client,
  network: state.client.clientNetwork,
  filters: state.filters.filters
});

const mapDispatchToProps = {
  updateFiltersAction: updateFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(Network);
